import React, { PureComponent } from 'react';
import Select from 'react-select';
import { DateRangePicker } from 'react-dates';
import 'react-dates/lib/css/_datepicker.css';
import 'react-dates/initialize';

class DownloadEximTrackingConfirmationPopup extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      focusedInput: null,
    };
  }

  render() {
    const { focusedInput } = this.state;
    const { downloadFrom, downloadTo, handleDownloadDatesChange, selectedDownloadOption, handleDownloadSelectChange, handleDownloadFile,downloadFileUrl } = this.props;
    const options = [
      { value: '3', label: 'CFS' },
      { value: '2', label: 'NON-SAP Data' },
    ];

    return (
      <div style={{
        background: 'white', padding: '20px', borderRadius: '5px',
        width: '400px'
      }}>
        Date Range:
        <div>
          <DateRangePicker
            startDate={downloadFrom}
            endDate={downloadTo}
            onDatesChange={handleDownloadDatesChange}
            focusedInput={focusedInput}
            onFocusChange={(focusedInput) => this.setState({ focusedInput })}
            numberOfMonths={1}
            isOutsideRange={() => false}
            displayFormat="DD/MM/YYYY"
          />
        </div>
        <br />
        <div style={{
          width: '260px'
        }}>
          Type:
          <Select
            value={selectedDownloadOption}
            onChange={handleDownloadSelectChange}
            options={options}
            style={{ marginBottom: '15px' }}
          />
        </div>
        <br />
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}>
          <a
            id="SFTPfile"
            href={downloadFileUrl}
            ref={(ref) => { this.downloadFileUrlButton = ref; }}>
            <button
              style={{ padding: '8px 16px', border: 'none', background: '#007BFF', color: 'white', cursor: 'pointer', borderRadius: '3px' }}
              onClick={handleDownloadFile}
            > Continue </button>
          </a>
        </div>
      </div>
    );
  }
}

export default DownloadEximTrackingConfirmationPopup;
